import {
  GroupedOption,
  OptionsProps,
} from "~/components/Form/components/SelectMenu/SelectMenu";

export function isGroupedOptions(
  options: OptionsProps,
): options is GroupedOption[] {
  return (
    Array.isArray(options) &&
    typeof options[0] === "object" &&
    "groupLabel" in options[0] &&
    Array.isArray((options[0] as GroupedOption).options)
  );
}
